const textFieldFormParamUser = {
  name: 'Full name',
  email: 'Email',
  
};

export default textFieldFormParamUser;
